import { B as Button, d as defineCustomElement$1 } from './p-35b617b4.js';
const OwcButton = Button;
const defineCustomElement = defineCustomElement$1;
export { OwcButton, defineCustomElement };